import { useAbilityStore } from "@/shared/store/ability.store";
import { storeToRefs } from "pinia";
import { Ability, SearchTab } from "@/shared/environment/ability.types";
import { computed, ComputedRef, Ref, ref } from "vue";
import { watchImmediate } from "@vueuse/core";
import { useRoute } from "vue-router";
import { CommonSearchTabAliases } from "@/shared/environment/common-route-aliases";
import { useAbilityRoute } from "@/shared/environment/ability-route";
import { useLoadConfigProductAndAsset } from "@/shared/configurations/product-and-asset/load-product-and-asset-settings";

export const useSearchTabsFromAbilities = (blobId?: Ref<string | undefined>) => {
    const abilityStore = useAbilityStore();
    const { abilities } = storeToRefs(abilityStore);
    const route = useRoute();

    const searchTabs = ref<SearchTab[]>([]);

    const { assetsActivated } = useLoadConfigProductAndAsset();
    const { getCurrentSearchParams } = useAbilityRoute();

    const searchTabsAll: ComputedRef<SearchTab[]> = computed(() => {
        const tabs: SearchTab[] = abilities.value
            .filter((ability: Ability) => {
                return !!ability.getSearchTabs;
            })
            .flatMap((x: Ability) => x.getSearchTabs!());
        return tabs;
    });

    const setSearchTabs = () => {
        const { searchParam } = getCurrentSearchParams();
        const { asset, product } = searchParam;

        const filteredTabs = searchTabsAll.value
            .map((tab: SearchTab) => {
                if (tab.alias !== CommonSearchTabAliases.commonArticles && blobId?.value) {
                    tab.disabled = true;
                }

                return tab;
            })
            .filter((tab: SearchTab) => {
                return !(tab.alias === CommonSearchTabAliases.assets && !assetsActivated.value);
            });

        if (!asset && !product) {
            searchTabs.value = filteredTabs;
        } else if (asset)
            searchTabs.value = [...filteredTabs].filter(
                (x) => x.alias !== CommonSearchTabAliases.products && x.alias !== CommonSearchTabAliases.assets
            );
        else if (product)
            searchTabs.value = [...filteredTabs].filter((x) => x.alias !== CommonSearchTabAliases.products);
        else searchTabs.value = [...filteredTabs];
    };

    watchImmediate(
        () => [assetsActivated.value, route.query, route.fullPath, blobId?.value],
        () => {
            setSearchTabs();
        }
    );

    return {
        searchTabs,
    };
};
